import { useId } from 'react'

export function JobiBotChristmas({ size = 74 }: { size?: number }) {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlSpace="preserve"
				id="Calque_1"
				width={size + 10}
				height={size + 10}
				x={0}
				y={0}
				enableBackground={'new 0 0 90.4 112.1'}
				viewBox="-5 -5 100.4 122.1"
				style={{ overflow: 'visible' }}
			>
				<style>
					{'.st0{fill:#fff}.st5{fill:#00c9ff}.st7{fill:#33d4ff}.st8{fill:#66deff}.st11{opacity:8.000000e-02;fill:#183b48}'}
				</style>
				<g fill="none" fillRule="nonzero" className="jobibot">
					<path
						d="M80.4 53.9c0-1.8-.6-3.3-1.5-4.5-1.3-1.7-3.3-3-5.9-3H17.6c-4.2 0-7.6 3.4-7.6 7.6v39.9c0 1.8.6 3.3 1.5 4.5 1.3 1.7 3.3 3 5.9 3h55.3c4.2 0 7.6-3.4 7.6-7.6l.1-39.9c0 .1 0 0 0 0z"
						className="st0"
					/>
					<linearGradient
						id="SVGID_1_"
						x1={9.974}
						x2={80.453}
						y1={73.874}
						y2={73.874}
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset={0}
							style={{
								stopColor: '#8b00f3',
							}}
						/>
						<stop
							offset={1}
							style={{
								stopColor: '#2d3dff',
							}}
						/>
					</linearGradient>
					<path
						d="M10 93.8V54c0-4.2 3.4-7.6 7.6-7.6h55.2c7.4 0 10.5 9.5 4.4 13.8L22 100c-5 3.6-12 0-12-6.2z"
						style={{
							fill: 'url(#SVGID_1_)',
						}}
					/>
					<linearGradient
						id="SVGID_00000062163381325855164540000001884205091839371941_"
						x1={9.974}
						x2={80.453}
						y1={73.874}
						y2={73.874}
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset={0}
							style={{
								stopColor: '#8b00f3',
							}}
						/>
						<stop
							offset={1}
							style={{
								stopColor: '#2d3dff',
							}}
						/>
					</linearGradient>
					<path
						d="M80.5 54v39.8c0 4.2-3.4 7.6-7.6 7.6H17.6c-7.4 0-10.5-9.5-4.4-13.8l55.2-39.8c5-3.6 12.1 0 12.1 6.2z"
						style={{
							opacity: 0.82,
							fill: 'url(#SVGID_00000062163381325855164540000001884205091839371941_)',
						}}
					/>
					<linearGradient
						id="SVGID_00000089531840131912590290000007215906087706222500_"
						x1={2382.512}
						x2={2373.808}
						y1={-1252.137}
						y2={-1237.061}
						gradientTransform="rotate(180 1217.924 -569.656)"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset={0}
							style={{
								stopColor: '#8b00f3',
							}}
						/>
						<stop
							offset={1}
							style={{
								stopColor: '#2d3dff',
							}}
						/>
					</linearGradient>
					<path
						d="M68.4 101.4H51.5v9.4c0 1.3 1.4 2 2.4 1.3l14.5-10.7z"
						style={{
							fill: 'url(#SVGID_00000089531840131912590290000007215906087706222500_)',
						}}
					/>
					<path
						d="M42.4 26.6h5.7v70.5h-5.7z"
						style={{
							opacity: 0.2,
							fill: '#183b48',
						}}
						transform="rotate(-90 45.223 61.828)"
					/>
					<circle cx={59.7} cy={73.8} r={17.3} className="st5" />
					<ellipse cx={59.7} cy={74} className="st0" rx={11.7} ry={11.8} />
					<linearGradient
						id="SVGID_00000067953907044669527680000005053699926075459223_"
						x1={53.268}
						x2={66.138}
						y1={74.014}
						y2={74.014}
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset={0}
							style={{
								stopColor: '#2d3dff',
							}}
						/>
						<stop
							offset={1}
							style={{
								stopColor: '#1413bb',
							}}
						/>
					</linearGradient>
					<g className="eye-container">
						<circle
							cx={59.7}
							cy={74}
							r={6.4}
							className="eyes"
							style={{
								fill: 'url(#SVGID_00000067953907044669527680000005053699926075459223_)',
							}}
						/>
					</g>
					<path
						d="M82.5 66.1H75c1.2 2.4 1.9 5 1.9 7.9s-.7 5.5-1.9 7.9h7.5c4.3 0 7.9-3.6 7.9-7.9 0-4.3-3.5-7.9-7.9-7.9z"
						className="st5"
					/>
					<path
						d="M82.5 81.9c4.4 0 7.9-3.6 7.9-7.9 0-4.3-3.6-7.9-7.9-7.9h-2v15.8h2z"
						className="st7"
					/>
					<path
						d="M77 74c0-2.8-.7-5.5-1.9-7.9h-6.6c1.9 2.1 3 4.9 3 7.9s-1.1 5.8-3 7.9H75c1.3-2.4 2-5 2-7.9z"
						className="st8"
					/>
					<circle cx={30.7} cy={73.9} r={17.3} className="st5" />
					<ellipse cx={30.7} cy={73.9} className="st0" rx={11.7} ry={11.8} />
					<linearGradient
						id="SVGID_00000035519670734679281510000013113118251916876732_"
						x1={8361.402}
						x2={8374.272}
						y1={73.874}
						y2={73.874}
						gradientTransform="matrix(-1 0 0 1 8398.55 0)"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset={0}
							style={{
								stopColor: '#2d3dff',
							}}
						/>
						<stop
							offset={1}
							style={{
								stopColor: '#1413bb',
							}}
						/>
					</linearGradient>
					<g className="eye-container">
						<circle
							cx={30.7}
							cy={73.9}
							r={6.4}
							className="eyes"
							style={{
								fill: 'url(#SVGID_00000035519670734679281510000013113118251916876732_)',
							}}
						/>
					</g>
					<path
						d="M7.9 66h7.5c-1.2 2.4-1.9 5-1.9 7.9s.7 5.5 1.9 7.9H7.9c-4.3 0-7.9-3.6-7.9-7.9C0 69.5 3.6 66 7.9 66z"
						className="st5"
					/>
					<path
						d="M7.9 81.8c-4.4 0-7.9-3.6-7.9-7.9C0 69.5 3.6 66 7.9 66h2v15.8h-2z"
						className="st7"
					/>
					<path
						d="M13.4 73.9c0-2.8.7-5.5 1.9-7.9H22c-1.9 2.1-3 4.9-3 7.9s1.1 5.8 3 7.9h-6.6c-1.3-2.4-2-5.1-2-7.9z"
						className="st8"
					/>
					<g className="antenna-christmas">
						<linearGradient
							id="SVGID_00000140698065433703488790000013495073331893355915_"
							x1={20.728}
							x2={71.43}
							y1={63.756}
							y2={13.054}
							gradientUnits="userSpaceOnUse"
						>
							<stop
								offset={0}
								style={{
									stopColor: '#ff0040',
								}}
							/>
							<stop
								offset={1}
								style={{
									stopColor: '#ff3f3c',
								}}
							/>
						</linearGradient>
						<path
							d="M8.5 51.5h73.3L65.4 29.9c-2.4-3.1-.1-7.6 3.8-7.6 4.2 0 6.3-5 3.4-8L60.4 2C59.5 1.1 58.3.6 57 .6H37c-1.8 0-3.4 1-4.2 2.6L8.5 51.5z"
							style={{
								fill: 'url(#SVGID_00000140698065433703488790000013495073331893355915_)',
							}}
						/>
						<path
							d="M32.8 3.1 8.6 51.5h35.7C30 50.2 21.2 34.8 27.7 21.7L37 3.2c.8-1.6 2.4-2.6 4.2-2.6h-5.1c-1.4.3-2.6 1.2-3.3 2.5zm33.8 18.5c0 .5 0 .9.1 1.3.7-.4 1.5-.6 2.4-.6 4.2 0 6.3-5 3.4-8l-.8-.8c-3 1.5-5.1 4.6-5.1 8.1z"
							className="st11"
						/>
						<circle cx={77.9} cy={20.3} r={9.1} className="st0" />
						<path
							d="M71.9 17.2c0-1.7.5-3.3 1.3-4.7-2.6 1.6-4.4 4.5-4.4 7.8 0 5 4.1 9.1 9.1 9.1 3.3 0 6.2-1.8 7.8-4.4-1.4.8-3 1.3-4.7 1.3-5 0-9.1-4.1-9.1-9.1z"
							className="st11"
						/>
						<path
							d="M80.2 65.2 9.3 60.8C8 60.7 7 59.6 7.1 58.4l.6-9.4c.1-1.3 1.2-2.3 2.5-2.2L81 51.1c1.3.1 2.3 1.2 2.2 2.5l-.6 9.4c0 1.3-1.1 2.3-2.4 2.2z"
							className="st0"
						/>
						<path d="m6.972 60.698.21-3.394 75.556 4.68-.21 3.394z" className="st11" />
					</g>
				</g>
			</svg>
		</>
	)
}

export function Jobibot({ size = 74 }: { size?: number }) {
	const currentDate = new Date()
	const month = currentDate.getMonth()
	const day = currentDate.getDate()
	if (month === 11) {
		return <JobiBotChristmas size={size} />
	}

	if (month === 9 && day >= 20) {
		return <JobibotHalloween size={size} />
	}

	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 75 74">
				<defs>
					<linearGradient id="a" x1="-.007%" x2="100.015%" y1="49.987%" y2="49.987%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#39D0FD" />
					</linearGradient>
					<linearGradient id="b" x1=".004%" x2="100%" y1="50%" y2="50%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="c" x1="-.006%" x2="100.003%" y1="49.999%" y2="49.999%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="d" x1="10.929%" x2="62.491%" y1="72.18%" y2="15.615%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="e" x1="14.645%" x2="85.377%" y1="85.394%" y2="14.662%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="f" x1=".046%" x2="99.999%" y1="50.028%" y2="50.028%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#1028AE" />
					</linearGradient>
					<linearGradient id="g" x1="99.978%" x2=".024%" y1="49.998%" y2="49.998%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#1028AE" />
					</linearGradient>
				</defs>
				<g fill="none" fillRule="nonzero" className="jobibot">
					<path
						fill="#FFF"
						d="M67 25.317c0-.008 0-.008 0 0a6.288 6.288 0 0 0-1.28-3.778c-1.075-1.459-2.779-2.486-4.944-2.539h-46.4A6.377 6.377 0 0 0 8 25.377v33.306c.015 1.466.5 2.75 1.28 3.778 1.075 1.459 2.779 2.486 4.944 2.539h46.4A6.377 6.377 0 0 0 67 58.623V25.317Z"
					/>
					<g className="antenna">
						<path
							fill="transparent"
							d="M67 25.317c0-.008 0-.008 0 0a6.288 6.288 0 0 0-1.28-3.778c-1.075-1.459-2.779-2.486-4.944-2.539h-46.4A6.377 6.377 0 0 0 8 25.377v33.306c.015 1.466.5 2.75 1.28 3.778 1.075 1.459 2.779 2.486 4.944 2.539h46.4A6.377 6.377 0 0 0 67 58.623V25.317Z"
						/>
						<path fill="#304FFB" d="M35 5h5v10h-5z" />
						<circle cx="38" cy="6" r="6" fill="url(#e)" />
					</g>
					<path
						fill="url(#a)"
						d="M48.887 15H26.113C23.843 15 22 16.792 22 19s1.843 4 4.113 4h22.774C51.157 23 53 21.208 53 19c.007-2.208-1.835-4-4.113-4Z"
					/>
					<path
						fill="url(#b)"
						d="M8 58.61V25.383A6.383 6.383 0 0 1 14.38 19h46.23c6.199 0 8.75 7.946 3.724 11.564l-46.23 33.228C13.881 66.82 8 63.807 8 58.61Z"
					/>
					<path
						fill="url(#c)"
						d="M67 25.39v33.227A6.383 6.383 0 0 1 60.619 65H14.39c-6.2 0-8.75-7.946-3.725-11.564l46.236-33.228C61.118 17.18 67 20.193 67 25.39Z"
						opacity=".82"
					/>
					<path fill="url(#d)" d="M57 65H43v7.706c0 1.056 1.185 1.662 2.032 1.049L57 65Z" />
					<g transform="translate(35 28)">
						<ellipse cx="14.386" cy="14.5" fill="#07C4FC" rx="14.386" ry="14.5" />
						<ellipse cx="14.386" cy="14.652" fill="#FFF" rx="9.787" ry="9.895" />
						<g className="eye-container">
							<ellipse cx="14.386" cy="14.652" fill="url(#f)" className="eyes" rx="5.369" ry="5.411" />
						</g>
					</g>
					<path
						fill="#07C4FC"
						d="M68.418 36.025h-6.236a14.413 14.413 0 0 1 1.613 6.635c0 2.394-.58 4.65-1.613 6.634h6.236c3.619 0 6.582-2.987 6.582-6.634 0-3.656-2.963-6.635-6.582-6.635Z"
					/>
					<path
						fill="#39D0FD"
						d="M68.387 49.286c3.635 0 6.605-2.986 6.605-6.634s-2.97-6.634-6.605-6.634h-1.704v13.268h1.704Z"
					/>
					<path
						fill="#6ADCFD"
						d="M63.795 42.652c0-2.394-.58-4.65-1.613-6.634h-5.535a9.926 9.926 0 0 1 2.526 6.634 9.926 9.926 0 0 1-2.526 6.634h5.535a14.32 14.32 0 0 0 1.613-6.634Z"
					/>
					<g transform="translate(11.227 28)">
						<ellipse cx="14.386" cy="14.5" fill="#07C4FC" rx="14.386" ry="14.5" />
						<ellipse cx="14.386" cy="14.5" fill="#FFF" rx="9.787" ry="9.895" />
						<g className="eye-container">
							<ellipse cx="14.386" cy="14.5" fill="url(#g)" className="eyes" rx="5.369" ry="5.411" />
						</g>
					</g>
					<path
						fill="#07C4FC"
						d="M6.582 35.866h6.236a14.413 14.413 0 0 0-1.613 6.634c0 2.394.58 4.651 1.613 6.634H6.582C2.963 49.134 0 46.148 0 42.5s2.963-6.634 6.582-6.634Z"
					/>
					<path
						fill="#39D0FD"
						d="M6.613 49.134c-3.635 0-6.605-2.986-6.605-6.634s2.97-6.634 6.605-6.634h1.704v13.268H6.613Z"
					/>
					<path
						fill="#6ADCFD"
						d="M11.205 42.5c0-2.394.58-4.65 1.613-6.634h5.534a9.926 9.926 0 0 0-2.525 6.634c0 2.553.957 4.879 2.525 6.634h-5.534a14.437 14.437 0 0 1-1.613-6.634Z"
					/>
				</g>
			</svg>
		</>
	)
}

function JobibotHalloween({ size = 150 }: { size?: number }) {
	// Unique gradient ids so several bots on one page don't clash.
	const uid = 'jb' + useId().replace(/[^a-zA-Z0-9_-]/g, '')
	const id = (name: string) => `${uid}-${name}`
	const url = (name: string) => `url(#${id(name)})`

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 -22 75 96"
			width={size}
			height={(size * 96) / 75}
			role="img"
			aria-label="Jobibot"
			className="jbh"
		>
			<style>{styles}</style>
			<defs>
				<linearGradient id={id('o-a')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#304FFB" />
					<stop offset="100%" stopColor="#39D0FD" />
				</linearGradient>
				<linearGradient id={id('o-b')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#710DE0" />
					<stop offset="100%" stopColor="#304FFB" />
				</linearGradient>
				<linearGradient id={id('o-d')} x1="10.929%" x2="62.491%" y1="72.18%" y2="15.615%">
					<stop offset="0%" stopColor="#710DE0" />
					<stop offset="100%" stopColor="#304FFB" />
				</linearGradient>
				<linearGradient id={id('o-e')} x1="14.645%" x2="85.377%" y1="85.394%" y2="14.662%">
					<stop offset="0%" stopColor="#710DE0" />
					<stop offset="100%" stopColor="#304FFB" />
				</linearGradient>
				<linearGradient id={id('o-f')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#304FFB" />
					<stop offset="100%" stopColor="#1028AE" />
				</linearGradient>
				<linearGradient id={id('o-g')} x1="100%" x2="0%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#304FFB" />
					<stop offset="100%" stopColor="#1028AE" />
				</linearGradient>

				<linearGradient id={id('h-a')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#FF6A00" />
					<stop offset="100%" stopColor="#FFB627" />
				</linearGradient>
				<linearGradient id={id('h-b')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#2B0A4F" />
					<stop offset="100%" stopColor="#6A1FB0" />
				</linearGradient>
				<linearGradient id={id('h-c')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#FF6A00" />
					<stop offset="100%" stopColor="#FF9A1F" />
				</linearGradient>
				<linearGradient id={id('h-d')} x1="10.929%" x2="62.491%" y1="72.18%" y2="15.615%">
					<stop offset="0%" stopColor="#C94A00" />
					<stop offset="100%" stopColor="#FF7A00" />
				</linearGradient>
				<linearGradient id={id('h-f')} x1="0%" x2="100%" y1="50%" y2="50%">
					<stop offset="0%" stopColor="#1A0B2E" />
					<stop offset="100%" stopColor="#3B1166" />
				</linearGradient>
				<linearGradient id={id('h-hat')} x1="0%" x2="100%" y1="0%" y2="100%">
					<stop offset="0%" stopColor="#3B1166" />
					<stop offset="100%" stopColor="#14071F" />
				</linearGradient>
				<radialGradient id={id('h-glow')} cx="50%" cy="50%" r="50%">
					<stop offset="0%" stopColor="#F4FFB0" />
					<stop offset="100%" stopColor="#B6FF3B" />
				</radialGradient>
			</defs>

			{/* Hit area so the whole box reacts to hover */}
			<rect x="0" y="-22" width="75" height="96" fill="transparent" />

			<g className="jobibot">
				{/* Original Jobibot */}
				<g className="jbh-orig" fill="none" fillRule="nonzero">
					<path fill="#FFF" d={BODY} />
					<g className="antenna">
						<path fill="#304FFB" d="M35 5h5v10h-5z" />
						<circle cx="38" cy="6" r="6" fill={url('o-e')} />
					</g>
					<path
						fill={url('o-a')}
						d="M48.887 15H26.113C23.843 15 22 16.792 22 19s1.843 4 4.113 4h22.774C51.157 23 53 21.208 53 19c.007-2.208-1.835-4-4.113-4Z"
					/>
					<path fill={url('o-b')} d={HALF_L} />
					<path fill={url('o-b')} d={HALF_R} opacity=".82" />
					<path fill={url('o-d')} d={TAIL} />
					<Eye
						x={35}
						cyPupil={14.652}
						ring="#07C4FC"
						white="#FFF"
						pupil={url('o-f')}
						prx={5.369}
						pry={5.411}
					/>
					<Eye
						x={11.227}
						cyPupil={14.5}
						ring="#07C4FC"
						white="#FFF"
						pupil={url('o-g')}
						prx={5.369}
						pry={5.411}
					/>
					<Ears a="#07C4FC" b="#39D0FD" c="#6ADCFD" />
				</g>

				{/* Halloween Jobibot */}
				<g className="jbh-spooky" fill="none" fillRule="nonzero">
					<path fill="#FFF" d={BODY} />
					<path fill={url('h-b')} d={HALF_L} />
					<path fill={url('h-c')} d={HALF_R} opacity=".85" />
					<path fill={url('h-d')} d={TAIL} />
					<Eye
						x={35}
						cyPupil={14.652}
						ring="#1A0B2E"
						white={url('h-glow')}
						pupil={url('h-f')}
						prx={2}
						pry={7}
					/>
					<Eye
						x={11.227}
						cyPupil={14.5}
						ring="#1A0B2E"
						white={url('h-glow')}
						pupil={url('h-f')}
						prx={2}
						pry={7}
					/>
					<Ears a="#1A0B2E" b="#FF7A00" c="#FFB627" />
					<g className="mouth">
						<path fill="#1A0B2E" d="M30.5 57.5 Q37.5 63.5 44.5 57.5 Q37.5 60 30.5 57.5 Z" />
						<path fill="#FFF" d="M33.4 58.9 L34.6 61.6 L35.6 59.4 Z M39.4 59.4 L40.4 61.6 L41.6 58.9 Z" />
					</g>
				</g>

				{/* Witch hat */}
				<g className="jbh-hat">
					<path
						fill={url('h-hat')}
						d="M24 16 C30 4 36 -6 44 -16 C46 -19 49 -20 52 -17 C49 -16 47 -13 47 -9 C47 0 49 8 51 16 Z"
					/>
					<ellipse cx="37.5" cy="16.5" fill="#14071F" rx="24" ry="4.2" />
					<path
						fill={url('h-a')}
						d="M25.6 12.2 C33 13.6 42 13.6 49.6 12.2 L50.6 15.6 C42 17.2 33 17.2 24.4 15.6 Z"
					/>
					<rect width="5" height="5" x="35" y="11.8" fill="none" stroke="#FFD34D" strokeWidth="1.2" rx=".6" />
				</g>

				{/* Bat */}
				<g className="jbh-bat" fill="#1A0B2E">
					<path d="M66 -6 C64 -9 61 -9 59 -7 C60.5 -6.8 61.2 -5.8 61 -4.6 C62.4 -5.4 63.8 -5 64.6 -4 C65 -4.6 65.6 -4.8 66 -4.8 C66.4 -4.8 67 -4.6 67.4 -4 C68.2 -5 69.6 -5.4 71 -4.6 C70.8 -5.8 71.5 -6.8 73 -7 C71 -9 68 -9 66 -6 Z" />
					<circle cx="66" cy="-5.6" r="1.2" />
				</g>
			</g>
		</svg>
	)
}

function Eye({ x, cyPupil, ring, white, pupil, prx, pry }) {
	return (
		<g transform={`translate(${x} 28)`}>
			<ellipse cx="14.386" cy="14.5" fill={ring} rx="14.386" ry="14.5" />
			<ellipse cx="14.386" cy={cyPupil} fill={white} rx="9.787" ry="9.895" />
			<g className="eye-container">
				<ellipse className="eyes" cx="14.386" cy={cyPupil} fill={pupil} rx={prx} ry={pry} />
			</g>
		</g>
	)
}

function Ears({ a, b, c }) {
	return (
		<>
			<path
				fill={a}
				d="M68.418 36.025h-6.236a14.413 14.413 0 0 1 1.613 6.635c0 2.394-.58 4.65-1.613 6.634h6.236c3.619 0 6.582-2.987 6.582-6.634 0-3.656-2.963-6.635-6.582-6.635Z"
			/>
			<path
				fill={b}
				d="M68.387 49.286c3.635 0 6.605-2.986 6.605-6.634s-2.97-6.634-6.605-6.634h-1.704v13.268h1.704Z"
			/>
			<path
				fill={c}
				d="M63.795 42.652c0-2.394-.58-4.65-1.613-6.634h-5.535a9.926 9.926 0 0 1 2.526 6.634 9.926 9.926 0 0 1-2.526 6.634h5.535a14.32 14.32 0 0 0 1.613-6.634Z"
			/>
			<path
				fill={a}
				d="M6.582 35.866h6.236a14.413 14.413 0 0 0-1.613 6.634c0 2.394.58 4.651 1.613 6.634H6.582C2.963 49.134 0 46.148 0 42.5s2.963-6.634 6.582-6.634Z"
			/>
			<path
				fill={b}
				d="M6.613 49.134c-3.635 0-6.605-2.986-6.605-6.634s2.97-6.634 6.605-6.634h1.704v13.268H6.613Z"
			/>
			<path
				fill={c}
				d="M11.205 42.5c0-2.394.58-4.65 1.613-6.634h5.534a9.926 9.926 0 0 0-2.525 6.634c0 2.553.957 4.879 2.525 6.634h-5.534a14.437 14.437 0 0 1-1.613-6.634Z"
			/>
		</>
	)
}

const BODY =
	'M67 25.317a6.288 6.288 0 0 0-1.28-3.778c-1.075-1.459-2.779-2.486-4.944-2.539h-46.4A6.377 6.377 0 0 0 8 25.377v33.306c.015 1.466.5 2.75 1.28 3.778 1.075 1.459 2.779 2.486 4.944 2.539h46.4A6.377 6.377 0 0 0 67 58.623V25.317Z'
const HALF_L =
	'M8 58.61V25.383A6.383 6.383 0 0 1 14.38 19h46.23c6.199 0 8.75 7.946 3.724 11.564l-46.23 33.228C13.881 66.82 8 63.807 8 58.61Z'
const HALF_R =
	'M67 25.39v33.227A6.383 6.383 0 0 1 60.619 65H14.39c-6.2 0-8.75-7.946-3.725-11.564l46.236-33.228C61.118 17.18 67 20.193 67 25.39Z'
const TAIL = 'M57 65H43v7.706c0 1.056 1.185 1.662 2.032 1.049L57 65Z'

/*
 * Timing notes
 * - The base rules below describe the EXIT (mouse leaves): it plays in reverse
 *   order of the entrance (bat, then hat, then costume, then original bot),
 *   uses plain ease curves with no overshoot, and smaller rotations, so
 *   nothing snaps back at once.
 * - The :hover rules describe the ENTRANCE, with its own bouncy curves and delays.
 */
const styles = `
.jbh { cursor: pointer; }
.jbh-orig, .jbh-spooky, .jbh-hat, .jbh-bat {
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

/* ---------- resting state + exit transitions ---------- */
.jbh-orig {
  transform-origin: 37.5px 42px;
  transition-duration: .4s, .6s;
  transition-timing-function: ease-out, cubic-bezier(.22,1,.36,1);
  transition-delay: .2s, .2s;
}
.jbh-spooky {
  opacity: 0;
  transform-origin: 37.5px 42px;
  transform: scale(.85) rotate(-12deg);
  transition-duration: .35s, .5s;
  transition-timing-function: ease-in-out, cubic-bezier(.4,0,.2,1);
  transition-delay: .12s, .12s;
}
.jbh-hat {
  opacity: 0;
  transform-origin: 37.5px 16px;
  transform: translate(-4px,-28px) rotate(-22deg);
  transition-duration: .3s, .4s;
  transition-timing-function: ease-in, cubic-bezier(.4,0,.6,1);
  transition-delay: .05s, .05s;
}
.jbh-bat {
  opacity: 0;
  transform-origin: 66px -6px;
  transform: translate(-60px,24px) scale(.3) rotate(-30deg);
  transition-duration: .25s, .35s;
  transition-timing-function: ease-in, cubic-bezier(.4,0,.6,1);
  transition-delay: 0s, 0s;
}

/* ---------- hovered state + entrance transitions ---------- */
.jbh:hover .jbh-orig {
  opacity: 0;
  transform: scale(1.1) rotate(15deg);
  transition-duration: .3s, .5s;
  transition-timing-function: ease, cubic-bezier(.55,0,.1,1);
  transition-delay: 0s, 0s;
}
.jbh:hover .jbh-spooky {
  opacity: 1;
  transform: none;
  transition-duration: .35s, .6s;
  transition-timing-function: ease, cubic-bezier(.34,1.56,.64,1);
  transition-delay: .05s, .05s;
}
.jbh:hover .jbh-hat {
  opacity: 1;
  transform: none;
  transition-duration: .2s, .55s;
  transition-timing-function: ease, cubic-bezier(.34,1.7,.64,1);
  transition-delay: .2s, .2s;
}
.jbh:hover .jbh-bat {
  opacity: 1;
  transform: none;
  transition-duration: .2s, .7s;
  transition-timing-function: ease, cubic-bezier(.22,1,.36,1);
  transition-delay: .4s, .4s;
}

@media (prefers-reduced-motion: reduce) {
  .jbh-orig, .jbh-spooky, .jbh-hat, .jbh-bat {
    transform: none !important;
    transition-property: opacity !important;
    transition-delay: 0s !important;
  }
}
`
